import React from 'react';
import './About-us.css';

const About = () => {
  const values = [
    {
      icon: 'fas fa-lightbulb',
      title: 'Innovation',
      description: 'We constantly explore new technologies and methodologies to deliver cutting-edge solutions.'
    },
    {
      icon: 'fas fa-heart',
      title: 'Client-Centric',
      description: 'Your success is our success. We prioritize your goals and work as an extension of your team.'
    },
    {
      icon: 'fas fa-handshake',
      title: 'Integrity',
      description: 'We believe in honest communication, transparent processes, and ethical business practices.'
    },
    {
      icon: 'fas fa-chart-line',
      title: 'Excellence',
      description: 'We strive for perfection in every project, ensuring the highest quality standards.'
    }
  ];

  const achievements = [
    { number: '100+', label: 'Projects Delivered', icon: 'fas fa-project-diagram' },
    { number: '50+', label: 'Happy Clients', icon: 'fas fa-users' },
    { number: '5+', label: 'Years Experience', icon: 'fas fa-calendar-alt' },
    { number: '98%', label: 'Client Satisfaction', icon: 'fas fa-star' }
  ];

  const services = [
    {
      icon: 'fas fa-mobile-alt',
      title: 'Mobile Development',
      description: 'Native and cross-platform mobile apps for iOS and Android'
    },
    {
      icon: 'fas fa-globe',
      title: 'Web Development',
      description: 'Responsive websites and web applications built with modern frameworks'
    },
    {
      icon: 'fas fa-palette',
      title: 'UI/UX Design',
      description: 'Beautiful, intuitive interfaces that enhance user experience'
    },
    {
      icon: 'fas fa-robot',
      title: 'AI Solutions',
      description: 'Intelligent chatbots and automation tools powered by AI'
    }
  ];

  const process = [
    {
      step: '01',
      title: 'Discovery',
      description: 'We start by understanding your business, goals, and target audience through comprehensive research and consultation.'
    },
    {
      step: '02',
      title: 'Planning',
      description: 'Our team creates a detailed roadmap, timeline, and strategy tailored to your specific needs and budget.'
    },
    {
      step: '03',
      title: 'Design',
      description: 'We design intuitive interfaces and user experiences that align with your brand and user expectations.'
    },
    {
      step: '04',
      title: 'Development',
      description: 'Using agile methodology, we build your solution with clean code, best practices, and regular updates.'
    },
    {
      step: '05',
      title: 'Testing',
      description: 'Rigorous testing ensures your product is bug-free, secure, and performs flawlessly across all platforms.'
    },
    {
      step: '06',
      title: 'Launch & Support',
      description: 'We help you launch successfully and provide ongoing support to ensure continued success and growth.'
    }
  ];

  return (
    <section id="about" className="about">
      <div className="about-container">
        <div className="about-header">
          <h2 className="section-title">About Tech Update</h2>
          <p className="section-subtitle">Your Trusted Technology Partner</p>
          <p className="section-description">
            We specialize in transforming ideas into powerful digital products that drive growth and success.
          </p>
        </div>

        <div className="about-content">
          <div className="about-text">
            <div className="about-description">
              <p>
                Tech Update is a dynamic startup founded with a mission to empower businesses through innovative 
                technology solutions. We specialize in transforming ideas into powerful digital products that drive 
                growth and success.
              </p>
              <p>
                Our team of experienced developers, designers, and strategists work together to deliver solutions 
                that are not just functional, but also beautiful, scalable, and user-friendly. We believe in 
                building long-term partnerships with our clients, understanding their unique needs, and providing 
                tailored solutions that exceed expectations.
              </p>
              <p>
                Whether you're a startup looking to launch your first app, or an established business seeking to 
                modernize your digital presence, we're here to help you succeed in the digital landscape.
              </p>
            </div>
            <div className="about-features">
              <div className="about-feature">
                <div className="feature-icon">
                  <i className="fas fa-rocket"></i>
                </div>
                <div className="feature-content">
                  <h4>Fast Delivery</h4>
                  <p>We deliver projects on time without compromising quality</p>
                </div>
              </div>
              <div className="about-feature">
                <div className="feature-icon">
                  <i className="fas fa-users"></i>
                </div>
                <div className="feature-content">
                  <h4>Expert Team</h4>
                  <p>Skilled professionals with years of industry experience</p>
                </div>
              </div>
              <div className="about-feature">
                <div className="feature-icon">
                  <i className="fas fa-shield-alt"></i>
                </div>
                <div className="feature-content">
                  <h4>Secure & Reliable</h4>
                  <p>Your data and applications are built with security in mind</p>
                </div>
              </div>
            </div>
          </div>
          <div className="about-image">
            <div className="about-graphic">
              <div className="tech-stack">
                <div className="tech-item">
                  <i className="fab fa-react"></i>
                  <span>React</span>
                </div>
                <div className="tech-item">
                  <i className="fab fa-android"></i>
                  <span>Android</span>
                </div>
                <div className="tech-item">
                  <i className="fab fa-apple"></i>
                  <span>iOS</span>
                </div>
                <div className="tech-item">
                  <i className="fab fa-node-js"></i>
                  <span>Node.js</span>
                </div>
                <div className="tech-item">
                  <i className="fab fa-wordpress"></i>
                  <span>WordPress</span>
                </div>
                <div className="tech-item">
                  <i className="fas fa-robot"></i>
                  <span>AI/ML</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mission & Vision Section */}
        <div className="mission-vision">
          <div className="mission-card">
            <div className="mission-icon">
              <i className="fas fa-bullseye"></i>
            </div>
            <h3>Our Mission</h3>
            <p>
              To empower businesses of all sizes with innovative technology solutions that drive growth, 
              enhance productivity, and create exceptional digital experiences. We aim to be the trusted 
              partner that helps companies navigate the digital landscape with confidence and success.
            </p>
          </div>
          <div className="vision-card">
            <div className="vision-icon">
              <i className="fas fa-eye"></i>
            </div>
            <h3>Our Vision</h3>
            <p>
              To become a leading technology partner recognized for excellence, innovation, and client success. 
              We envision a future where every business, regardless of size, has access to world-class digital 
              solutions that enable them to compete and thrive in the global marketplace.
            </p>
          </div>
        </div>

        {/* Achievements Section */}
        <div className="achievements-section">
          <h2 className="section-title">Our Achievements</h2>
          <p className="section-subtitle">Numbers That Speak for Themselves</p>
          <div className="achievements-grid">
            {achievements.map((achievement, index) => (
              <div key={index} className="achievement-card">
                <div className="achievement-icon">
                  <i className={achievement.icon}></i>
                </div>
                <h3 className="achievement-number">{achievement.number}</h3>
                <p className="achievement-label">{achievement.label}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Core Values Section */}
        <div className="values-section">
          <h2 className="section-title">Our Core Values</h2>
          <p className="section-subtitle">What Drives Us Every Day</p>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">
                  <i className={value.icon}></i>
                </div>
                <h3>{value.title}</h3>
                <p>{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* What We Do Section */}
        <div className="services-overview">
          <h2 className="section-title">What We Do</h2>
          <p className="section-subtitle">Comprehensive Digital Solutions</p>
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-overview-card">
                <div className="service-overview-icon">
                  <i className={service.icon}></i>
                </div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Our Process Section */}
        <div className="process-section">
          <h2 className="section-title">Our Development Process</h2>
          <p className="section-subtitle">A Proven Methodology for Success</p>
          <div className="process-timeline">
            {process.map((item, index) => (
              <div key={index} className="process-item">
                <div className="process-step-number">{item.step}</div>
                <div className="process-content">
                  <h3>{item.title}</h3>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Why Choose Us Section */}
        <div className="why-choose-section">
          <h2 className="section-title">Why Choose Tech Update?</h2>
          <div className="why-choose-grid">
            <div className="why-choose-item">
              <i className="fas fa-code"></i>
              <h4>Cutting-Edge Technology</h4>
              <p>We use the latest frameworks, tools, and best practices to build future-proof solutions.</p>
            </div>
            <div className="why-choose-item">
              <i className="fas fa-clock"></i>
              <h4>Agile Methodology</h4>
              <p>Flexible development process with regular updates and quick iterations.</p>
            </div>
            <div className="why-choose-item">
              <i className="fas fa-headset"></i>
              <h4>24/7 Support</h4>
              <p>Round-the-clock assistance to ensure your project runs smoothly.</p>
            </div>
            <div className="why-choose-item">
              <i className="fas fa-dollar-sign"></i>
              <h4>Competitive Pricing</h4>
              <p>Premium quality solutions at prices that fit your budget.</p>
            </div>
            <div className="why-choose-item">
              <i className="fas fa-sync-alt"></i>
              <h4>Scalable Solutions</h4>
              <p>Build once, scale infinitely. Our solutions grow with your business.</p>
            </div>
            <div className="why-choose-item">
              <i className="fas fa-certificate"></i>
              <h4>Quality Assurance</h4>
              <p>Rigorous testing and quality checks ensure flawless performance.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
